



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { SimulatorData, SimulatorCampaign } from './SimulatorSummary.vue';
import PriceDisplay from './PriceDispay.vue';

@Component({
    components: {
        PriceDisplay
    }
})
export default class SimulatorPrice extends Vue {
    [x: string]: any;
    @Prop() simulatorData!: SimulatorData;
    @Prop() simulatorCampaign!: SimulatorCampaign;
    /*
    get campaignPrice() {
        console.log('calculating campaign price', this.simulatorCampaign.campaignPrice);
        if (this.simulatorCampaign) {
            console.log('calculating campaign price', this.simulatorCampaign.campaignPrice);
            return this.simulatorCampaign.campaignPrice;
        }
        return null;
    }
    */
}
